export default __webpack_public_path__ + "static/media/iconClutchpng.c533f89b.png";